import '../App.css';
import {
    Modal,
    Button,
    ListGroup,
    Accordion,
    AccordionHeader,
    AccordionBody,
    Stack,
    Card,
    CardFooter,
} from 'react-bootstrap';
import React, {
    Dispatch,
    SetStateAction,
    useState,
    useEffect,
    useCallback
} from 'react';
import Rule from '../schemas/Rule';

interface ModalProps {
    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
    fullscreen?: true | 'sm-down' | 'md-down' | 'lg-down' | 'xl-down' | 'xxl-down';
    rule: Rule | null
}

function RulesModal({ rule, show, setShow, fullscreen }: ModalProps) {
    const handleClose = () => setShow(false);

    function formatQnA(qNa: string) {
        if (!qNa || typeof qNa !== 'string') return '';

        const questionMarkIndex = qNa.indexOf('?');
        if (questionMarkIndex === -1) return qNa;

        const before = qNa.slice(0, questionMarkIndex + 1); // include the ?
        const after = qNa.slice(questionMarkIndex + 1).trim();

        // Use a class for styling instead of inline style
        return `${before}<br/><span class="qna-answer">${after}</span>`;
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            fullscreen={fullscreen || undefined}
            dir="rtl"
        >
            <Modal.Header>
                <Modal.Title>{rule?.title}</Modal.Title>
                <Button variant="light" onClick={handleClose}>
                    סגירה
                </Button>
            </Modal.Header>
            <Modal.Body>
                {rule?.articles.map((article, i) => (
                    <Accordion defaultActiveKey="0" alwaysOpen key={i} className="mb-3">

                        {/* Each article itself is open by default */}
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>
                                {article.rule}
                                </Accordion.Header>

                            <Accordion.Body>
                                {/* Inner Accordion for context and Q&A */}
                                <Accordion>
                                    {article.context && (
                                        <Accordion.Item eventKey="context">
                                            <Accordion.Header>רקע והסבר</Accordion.Header>
                                            <Accordion.Body>
                                                <div dir="rtl">{article.context}</div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )}

                                    {article.qNa && (
                                        <Accordion.Item eventKey="qna">
                                            <Accordion.Header>שו"ת ודוגמאות</Accordion.Header>
                                            <Accordion.Body>
                                                {/* Apply the formatting function here */}
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: formatQnA(article.qNa) }}
                                                />
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )}
                                </Accordion>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                ))}
            </Modal.Body>

            <Modal.Footer>

            </Modal.Footer>
        </Modal>
    );
}

export default RulesModal;